module.exports = __webpack_public_path__ + "img/mew-choose-app.f5c24399.png";